export const timeOffReasonStatuses = {
  ACTIVE: 'active',
  PASSIVE: 'passive',
}
